<template>
  <b-row>
    <b-col>
      <h1 legal-element="title"></h1>
      <main legal-element="content">
        <p class="text-center">
          <b-spinner type="grow" :style="{color: this.$store.getters.getBrandData().colors.primaryButtonBackground}"/>
        </p>
      </main>
    </b-col>
  </b-row>
</template>

<script>
/* eslint-disable new-cap */

export default {
  created: function () {
    let page = 'privacy-policy'
    switch (this.$route.path) {
      case '/privacy-notice':
        page = 'privacy-notice'
        break
      case '/terms':
        page = 'terms'
        break
      case '/privacy':
      default:
        page = 'privacy-policy'
    }
    let brand = this.$store.getters.getBrandData()
    if (brand.branding === 'digitalrewards') {
      page = 'rewards-' + page
    }
    let legal = document.createElement('script')
    legal.setAttribute('src', '//distro.quick-cdn.com/build/compliance/legal-page-injector.js')
    legal.setAttribute('page', page)
    legal.setAttribute('brand', brand.branding)
    document.body.appendChild(legal)
  },
  methods: {},
  components: {}
}
</script>
<style lang="less">
.main.container {
  h1 {
    text-align: center;
    font-size: 34px;
    margin-bottom: 14px;
  }

  main[legal-element=content] {
    text-align: left;
  }
}
</style>
